import { actionNameGenerator } from '../../../utils/commonUtil';

const domainPrefix = 'oaa';

const domainActionNameGenerator = actionNameGenerator(domainPrefix);

export const preFillValuePrimary = domainActionNameGenerator('preFillValuePrimary');
export const preFillValueSecondary = domainActionNameGenerator('preFillValueSecondary');
export const onChangeValuesEmail = domainActionNameGenerator('onChangeValuesEmail');
export const preFillValuePhonePrimary = domainActionNameGenerator('preFillValuePhonePrimary');
export const preFillValuePhoneSecondary = domainActionNameGenerator('preFillValuePhoneSecondary');
export const onChangeValuesPhone = domainActionNameGenerator('onChangeValuesPhone');
export const preFillValueAddressPrimary = domainActionNameGenerator('preFillValueAddressPrimary');
export const preFillValueAddressSecondary = domainActionNameGenerator('preFillValueAddressSecondary');
export const onChangeValuesAddress = domainActionNameGenerator('onChangeValuesAddress');
export const resetFormValuesAddress = domainActionNameGenerator('resetFormValuesAddress');
export const resetFormValuesPhone = domainActionNameGenerator('resetFormValuesPhone');
export const resetFormValuesEmail = domainActionNameGenerator('resetFormValuesEmail');
export const preFillValueInfoPrimary = domainActionNameGenerator('preFillValueInfoPrimary');
export const preFillValueInfoSecondary = domainActionNameGenerator('preFillValueInfoSecondary');
export const inputInfo = domainActionNameGenerator('inputInfo');
export const resetFormValuesInfo = domainActionNameGenerator('resetFormValuesInfo');
export const resetFormValuesRelatedContributor = domainActionNameGenerator('resetFormValuesRelatedContributor');
export const radioChangePrimary = domainActionNameGenerator('radioChangePrimary');
export const radioChangeSecondary = domainActionNameGenerator('radioChangeSecondary');
export const resetVariable = domainActionNameGenerator('resetVariable');
export const addAdvisorButtonDisable = domainActionNameGenerator('addAdvisorButtonDisable');
export const storePrimaryInfo = domainActionNameGenerator('storePrimaryInfo');
export const fetchZipCodeData = domainActionNameGenerator('fetchZipCodeData');
export const fetchRCData = domainActionNameGenerator('fetchRCData');
export const storeFeildValues = domainActionNameGenerator('storeFeildValues');
export const relContributorPrimary = domainActionNameGenerator('relatedContributorPrimary');
export const relContributorSecondary = domainActionNameGenerator('relatedContributorSecondary');
export const incrementDecrementCount = domainActionNameGenerator('incrementDecrementCount');
export const inputChange = domainActionNameGenerator('inputChange');
export const handleError = domainActionNameGenerator('handleError');
export const storePercentage = domainActionNameGenerator('storePercentage');
export const storeLegacyValues = domainActionNameGenerator('storeLegacyValues');
export const storeSuccessorValues = domainActionNameGenerator('storeSuccessorValues');
export const successorTab = domainActionNameGenerator('successorTab');
export const addSuccessorValues = domainActionNameGenerator('addSuccessorValues');
export const updateActivePageStepName = domainActionNameGenerator('updateActivePageStepName');
export const resetLegacy = domainActionNameGenerator('resetLegacy');
export const showRemainingPercentage = domainActionNameGenerator('showRemainingPercentage');
export const stepTwoAccordionToggleStatus = domainActionNameGenerator('stepTwoAccordionToggleStatus');
export const stepTwoUpdateButton = domainActionNameGenerator('stepTwoUpdateButton');
export const removeValues = domainActionNameGenerator('removeValues');
export const mainPercentage = domainActionNameGenerator('showMainPercentage');
export const shouldCloseAccordion = domainActionNameGenerator('shouldCloseAccordion');
export const secondaryAdvisor = domainActionNameGenerator('isSecondaryAdvisor');
export const showMore = domainActionNameGenerator('shouldShowMore');
export const stepOneEdit = domainActionNameGenerator('step1Edit');
export const stepTwoEdit = domainActionNameGenerator('stepTwoEdit');
export const storeFinalJson = domainActionNameGenerator('storeFinalJson');
export const storeTempJson = domainActionNameGenerator('storeTempJson');
export const storeTempForStepOne = domainActionNameGenerator('storeTempForStepOne');
export const validateFinal = domainActionNameGenerator('validateSubmit');
export const initialContribution = domainActionNameGenerator('storeInitialContribution');
export const emptyZipStateCity = domainActionNameGenerator('emptyZipStateCity');
export const closeFormModal = domainActionNameGenerator('closeFormModal');
export const storeChnagesStepOneReducer = domainActionNameGenerator('storeChnagesStepOneReducer');
export const storeOaaEdit = domainActionNameGenerator('storeOaaEdit');
export const validationCheckStatus = domainActionNameGenerator('validationCheckStatus');
export const resetData = domainActionNameGenerator('resetFormData');
export const updateErrState = domainActionNameGenerator('updateErrorState');
export const updateAccordStatus = domainActionNameGenerator('updateAccordionStatus');
export const updateAccordState = domainActionNameGenerator('updateAccordionState');
export const setCityField = domainActionNameGenerator('setCityField');
export const fetchAlertContentsOaa = domainActionNameGenerator('fetchAlertContentsOaa');
export const submitFormSuccess = domainActionNameGenerator('submitFormSuccess');
export const submitFormError = domainActionNameGenerator('submitFormError');
export const fetchAlertSuccess = domainActionNameGenerator('fetchAlertSuccess');
export const fetchAlertError = domainActionNameGenerator('fetchAlertError');
export const fetchZipCode = domainActionNameGenerator('fetchZipCode');
export const ooaAccountDataRequestFailed = domainActionNameGenerator('ooaAccountDataRequestFailed');
export const oaaSubmitLoader = domainActionNameGenerator('oaaSubmitLoader');
export const hideSubmitLoader = domainActionNameGenerator('hideSubmitLoader');